import React, { useEffect } from 'react';
import styles from './conversations.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { fetchConversations } from 'actions/conversations';
import cx from 'classnames';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import defaultAsset from 'images/default_asset.jpg';
import { trackAdoptionMetricsForConversationViewedEvent } from 'actions/adoption';
import ReactTimeago from 'react-timeago';
import { REDIRECT_URL } from 'constants/actionTypes';

const webAppUrl = process.env.REACT_APP_WEBAPP_URL;

export default function Conversations(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const url = window.location.search;
  const regex = /[?&]source=([\w\d-]+)/;
  const matchResult = url.match(regex);
  const sourceValue = matchResult ? matchResult[1] : null;
  const conversations = useSelector((state) => _.get(state, 'conversations.items') || []);
  const conversationsLoading = useSelector((state) => _.get(state, 'conversations.loading') || false);
  const activeTab = useSelector((state) => _.get(state, 'application.activeTab') || null);

  const [isPaperflite, setIsPaperflite] = React.useState(false);

  useEffect(() => {
    if(_.size(conversations) === 0){
      dispatch(fetchConversations('', 0, "activity_date", "DESC", "all"));
    }
  }, [])

  useEffect(() => {
    if (activeTab && activeTab.includes("app.paperflite.com")) {
      setIsPaperflite(true);
    }
  }, [activeTab])

  const triggerMessageToPlugin = (message) => {
    window.parent.postMessage(message, "*");
  }

  const handleClick = (conversationUrl) => {
    dispatch(trackAdoptionMetricsForConversationViewedEvent("Conversation Viewed"))

    if(isPaperflite){
      triggerMessageToPlugin({
        type: REDIRECT_URL,
        payload: conversationUrl,
      });
    }
  }

  return (
    <>
      <div className={cx({ [styles.conversations]: props.conversationLimit == 25 })}>
        {/* This conditional check is for the full view of the conversation */}
        {props.conversationLimit == 25 && 
        <p className={styles.headerContainer}>
        <span className={styles.backButton} onClick={() => history.push(`/${sourceValue}`)}>
        <i className="paperflite-left-arrow"/>
        <span className={styles.back}>
          recent activities
        </span>
        </span>
        </p>
        }
        {props.carousel && <p className={styles.recentActivityTitle}>Recent Activity </p>}
        
        <div className={cx({ [styles.recentActivity]: props.conversationLimit == 25 })}>
          {conversationsLoading && _.times(props.conversationLimit).map((i) => {
            return (
              <div key={i} className={styles.conversationRow}>
                <img className={styles.conversationThumbnail} alt="conversation thumbnail" src={defaultAsset} />
                <div className={styles.conversationDetails}>
                  <p className={cx(styles.conversationSubject, styles.conversationSubjectPlaceholder)}>Subject</p>
                  <div className={styles.conversationRecipientPlaceholder}>
                    Recipients
                  </div>
                </div>
              </div>
            )
          })
          }
          {!conversationsLoading && conversations.map((conversation, i) => {
            let timeSpent = conversation.totalTimeSpent;
            let minutes = padNumber(Math.floor(timeSpent / 60), 2);
            let seconds = padNumber(Math.floor(timeSpent % 60), 2);
            const conversationUrl = `${webAppUrl}/conversations/${conversation.id}?source=chrome_extension`;

            if (i < props.conversationLimit) {
              return (
                <a key={conversation.id}
                 onClick={() => handleClick(conversationUrl)}
                 href={isPaperflite ? null : conversationUrl} target="_blank"
                 className={styles.conversationRow}>
                  <img className={styles.conversationThumbnail} alt="conversation thumbnail" src={_.get(conversation, "icon.thumbnail") || defaultAsset} />
                  <div className={styles.conversationDetails}>
                    <p className={styles.conversationSubject}>{conversation.subject}</p>

                    <p className={styles.conversationActivity}> 
                      <span>last active{" "}<ReactTimeago date={conversation.activityDate} live={false} /></span>
                      <i className={cx(styles.arrowIcon, 'paperflite-redirect')} />
                    </p>

                    <div className={styles.conversationWrapper}>
                      <div className={styles.conversationRecipient}>
                        {_.get(conversation, "recipients[0].contact") && <span>{_.get(conversation, "recipients[0].contact.firstName")}</span>}
                        {_.get(conversation, "recipients[0].visitor") && <span>{_.get(conversation, "recipients[0].visitor.firstName")}</span>}
                        {_.size(_.get(conversation, "recipients")) > 1 &&
                          <span className={styles.moreRecipient}> +{_.size(_.get(conversation, "recipients")) - 1} more</span>
                        }
                      </div>

                      <div className={cx(styles.analytics, {
                        [styles.hideAnalytics]: sourceValue === 'paperflite-home'
                      })}>
                      <span className={cx(styles.analyticsIcon, { [styles.disabled]: conversation.uniqueEmailOpens == 0 })}>
                        <span className={styles.conversationMetrics}><span className={cx("paperflite-mail-open", styles.metricsIcon)}></span>{conversation.totalRecipients > 0 ? formatPercentage((conversation.uniqueEmailOpens / conversation.totalRecipients)) : '0%'}</span>
                      </span>
                      <span className={cx(styles.analyticsIcon, { [styles.disabled]: conversation.uniqueLinkClicks == 0 })}>
                        <span className={styles.conversationMetrics}><span className={cx("paperflite-click-rate", styles.metricsIcon)}></span>{conversation.totalRecipients > 0 ? formatPercentage((conversation.uniqueLinkClicks / conversation.totalRecipients)) : '0%'}</span>
                      </span>
                      <span className={cx(styles.analyticsIcon, { [styles.disabled]: conversation.totalTimeSpent == 0 })}>
                        <span className={styles.conversationMetrics}><span className={cx("paperflite-clock", styles.metricsIcon)}></span>{`${minutes}:${seconds}`}</span>
                      </span>
                      </div>
                    </div>
                  </div>
                </a>
              )
            }
          })
          }
          {!conversationsLoading && _.size(conversations) === 0 && (
            <div className={styles.empty}>
              No recent activity
            </div>
          )}
        </div>
      </div>
    </>
  )
}

const padNumber = (number = 0, pad) => {
  const length = pad - String(number).length + 1;
  let padding = '';
  if (length > 0) {
    padding = Array(pad - String(number).length + 1).join('0');
  }
  return padding + number;
}

const formatPercentage = (percent) => {
  percent = percent || 0;
  percent = percent * 100;
  percent = percent.toFixed(0);

  if (percent > 100) {
    percent = 100;
  }

  return percent + '%';
}